/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * PayloadType tells the receiver about the content(s) of payload.
 * @export
 */
export const PayloadTypeConstants = {
    Empty: 'Empty',
    Incident: 'Incident',
    Redirect: 'Redirect',
    AppState: 'AppState',
    Page: 'Page',
    Section: 'Section',
    Session: 'Session',
    Options: 'Options',
    AutoCompletionResult: 'AutoCompletionResult',
    Confirm: 'Confirm',
    Command: 'Command',
    Commands: 'Commands',
    EntitySearchExtendedResult: 'EntitySearchExtendedResult',
    EntitySearchQuickResult: 'EntitySearchQuickResult',
    UserSettings: 'UserSettings',
    RowSelectionSettings: 'RowSelectionSettings',
    CopyToClipboard: 'CopyToClipboard'
} as const;
export type PayloadTypeConstants = typeof PayloadTypeConstants[keyof typeof PayloadTypeConstants];


export function PayloadTypeConstantsFromJSON(json: any): PayloadTypeConstants {
    return PayloadTypeConstantsFromJSONTyped(json, false);
}

export function PayloadTypeConstantsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PayloadTypeConstants {
    return json as PayloadTypeConstants;
}

export function PayloadTypeConstantsToJSON(value?: PayloadTypeConstants | null): any {
    return value as any;
}

